import { ChatThread } from './ChatThread';
import type { Order } from '@/types';
import { useAuthStore } from '@store/authStore';

interface OrderChatPanelProps {
  order: Order;
}

export function OrderChatPanel({ order }: OrderChatPanelProps) {
  const user = useAuthStore((s) => s.user);
  const partnerId = user?.role === 'wholesaler' ? order.restaurantId : order.wholesalerId;
  const partnerName =
    user?.role === 'wholesaler' ? order.restaurant?.name : order.wholesaler?.name;

  return (
    <div className="mt-3 border-t border-slate-100 pt-3">
      <p className="mb-2 text-sm font-medium text-slate-700">Sipariş Mesajları</p>
      <ChatThread
        partnerId={partnerId}
        partnerName={partnerName}
        orderId={order.id}
        compact
      />
    </div>
  );
}
